import aboutUsDesc from "../pages/aboutUs/aboutUs";
import appTexts from "../texts/appTexts";

const texts = {
  title: appTexts.pages.aboutUs,
  mainDesc: aboutUsDesc,
};

export default texts;
